// extracted by mini-css-extract-plugin
module.exports = {"container":"auth0-buttons_container__rQpKI","legalLinks":"auth0-buttons_legalLinks__AZfsz","auth0Button":"auth0-buttons_auth0Button__j98QW"};